import { OidcConfiguration } from '../@types';
import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetOidcConfigurationByCustomerRequest = {
	customerId?: number;
	shardName?: string;
};

export type GetOidcConfigurationByCustomerResponse = OidcConfiguration;

export const getOidcConfigurationByCustomer = createGetEndpoint<
	GetOidcConfigurationByCustomerRequest,
	GetOidcConfigurationByCustomerResponse
>((request) => `/api/v3/security/oidc/by-customer/${request?.customerId ?? 'current'}`, {
	headers: (request) => {
		if (request?.shardName) {
			return { [ HttpHeader.Shard ]: request.shardName };
		}

		return {};
	}
});
